// @flow

import React, {PureComponent} from 'react'
import type {Element} from 'react'

type ElementSize = {
  className: string,
  width: number
}

type ElementQueryProps = {
  children?: ?Element<any>,
  sizes: Array<ElementSize>
}

function byWidthDesc(a, b) {
  return b.width - a.width
}

export class ElementQuery extends PureComponent {
  props: ElementQueryProps
  node: any

  componentDidMount() {
    if (typeof window !== 'undefined' && window.nrkValgStaticSizeElement) {
      window.nrkValgStaticSizeElement(this.node)
    }
  }

  setNode = (node: any) => {
    this.node = node
  }

  render() {
    const sizes = [...this.props.sizes].sort(byWidthDesc)
    const sizesQuery = sizes
      .map(size => `${size.className}=${size.width}`)
      .join(',')
    return (
      <div data-element-query={sizesQuery} ref={this.setNode}>
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/shared/ElementQuery/index.js